/*eslint-disable*/
import {mapState} from 'vuex'

export default {
    methods: {
        canLinkToUser (user) {
            if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                return true;
            }
            if (this.user.type === 'admin') {
                return this.user.schoolsIds.some(id => user.schoolsIds.includes(id));
            }
            if (this.user.type === 'teacher' && user.type === 'teacher') {
                return true;
            }
            if (this.user.type === 'teacher' && user.grades && user.grades.length !== 0) {
                let userGradesIds = user.grades.map(grade => grade.id);
                let authUserGradesIds = this.user.grades.map(grade => grade.id);
                return Boolean(_.intersection(authUserGradesIds , userGradesIds).length);
            }
            return user.id === this.user.id;
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        })
    }
}
